// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".policy_modal{background-color:#ededed;border-radius:5px;font-size:14px;padding:20px}.policy_list{margin:10px 0 15px 18px;padding:0}.policy_list li{line-height:1.4;margin-bottom:8px}.policy_check{align-items:center;cursor:pointer;display:flex;font-weight:600;gap:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
